// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width: 768px) {\n  :host ion-app {\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    margin: 0 auto;\n  }\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
